var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_787",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 39
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Clip 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.849854H37.541V38.3915H0V0.849854Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_787)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1741 24.5553C32.1741 26.9013 30.344 28.5239 28.0252 28.5239C25.6801 28.5239 23.8509 26.9013 23.8509 24.5553V14.6596C23.8509 12.3153 25.6801 10.7173 28.0252 10.7173C30.344 10.7173 32.1741 12.3153 32.1741 14.6596V24.5553ZM22.5155 28.1882H20.6081L20.2741 27.0296C19.8091 27.9825 18.8299 28.5239 17.8516 28.5239C15.6093 28.5239 14.1915 26.9013 14.1915 24.6581V14.5567C14.1915 12.5218 15.8932 10.7173 18.3403 10.7173C20.7883 10.7173 22.3863 12.5218 22.3863 14.5567V17.3915H19.2685V14.5057C19.2685 14.0161 18.9591 13.7067 18.3922 13.7067C17.8516 13.7067 17.5413 14.0161 17.5413 14.5057V24.7865C17.5413 25.2769 17.8771 25.6365 18.4177 25.6365C18.9846 25.6365 19.3195 25.2769 19.3195 24.7865V21.9789H18.4432V19.6584H22.5155V28.1882ZM13.0814 13.9388H9.53688V18.0358H11.9594V20.715H9.53688V25.1741H13.0814V28.1882H6.23803V11.0267H13.0814V13.9388ZM18.7704 0.849609C8.40298 0.849609 -0.00012207 9.25441 -0.00012207 19.621C-0.00012207 29.9876 8.40298 38.3916 18.7704 38.3916C29.1379 38.3916 37.541 29.9876 37.541 19.621C37.541 9.25441 29.1379 0.849609 18.7704 0.849609Z",
    fill: "#12110F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.025 13.707C27.5872 13.707 27.2268 13.9901 27.2268 14.4542V24.7613C27.2268 25.2254 27.5872 25.5084 28.025 25.5084C28.4636 25.5084 28.7985 25.2254 28.7985 24.7613V14.4542C28.7985 13.9901 28.4636 13.707 28.025 13.707Z",
    fill: "#12110F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.6da4298f339fb6532227a4e3984788e1.svg";
export { ForwardRef as ReactComponent };